import SupplySetContainer from './supply-set-container';

export default SupplySetContainer;